import { Stack } from '@mui/material';
import { FC, memo, ReactNode, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router';
import AppBarContainerComponent from 'src/components/AppBarContainer.component';
import { appBarHeight } from 'src/constants/layout';
import LicenseContext from 'src/contexts/LicenseContext';

import AsyncJobSnackbar from './AsyncJobsSnackbar';

type Props = {
  children: ReactNode;
};

const V2DefaultLayout: FC<Props> = memo(({ children }) => {
  const licenseContext = useContext(LicenseContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!licenseContext.initialized) return;
    if (licenseContext.authenticated) return;

    void navigate('/login');
  }, [licenseContext.initialized, licenseContext.authenticated]);

  return (
    <Stack>
      <AppBarContainerComponent />
      <Stack
        sx={{
          position: 'relative',
          marginTop: `${appBarHeight}px`
        }}
      >
        {children}
      </Stack>
      <AsyncJobSnackbar />
    </Stack>
  );
});

export default V2DefaultLayout;
